<template>
  <div :class="vertical ? '' : 'form-row'">
    <b-col lg :class="vertical ? 'p-0' : ''">
      <ValidationProvider name="Email" :rules="{
        required: true,
        email: true,
        maineGovEmailRegex: !isGovEmail ? false : /[\w.+\-]*@[Mm][Aa][Ii][Nn][Ee]\.[Gg][Oo][Vv]$/
      }" v-slot="{ errors, classes }">
        <b-form-group label-for="email">
          <template v-slot:label><span class="req-ind">*</span>Email</template>
          <b-form-input
            type="email"
            id="email"
            name="email"
            v-model="account.email"
            placeholder="Enter Email"
            :class="classes"
            autocomplete="email"
            :aria-describedby="$errorsIdString(errors, 'email')"
          />
          <InputErrors :errors="errors" errorsIdPrefix="email" />
        </b-form-group>
      </ValidationProvider>
    </b-col>
    <b-col v-if="!isAdmin" lg :class="vertical ? 'p-0' : ''">
      <ValidationProvider
        :bails="false"
        :immediate="true"
        name="Password"
        :rules="'required|passwordMin:8|passwordNonAlpha|passwordNumber|passwordUppercase'
          + '|passwordLowercase|passwordNoSpaces|notSimilar:Email'"
        v-slot="{ errors, classes, pristine }"
      >
        <b-form-group label-for="password">
          <template v-slot:label>
            <span class="req-ind">*</span>{{newPassword ? 'New ' : '' }}Password
          </template>
          <b-form-input
            id="password"
            name="password"
            v-model="account.password"
            :placeholder="`Enter${newPassword ? ' New ' : ' ' }Password`"
            type="password"
            autocomplete="new-password"
            :class="pristine ? '' : classes"
            :aria-describedby="$errorsIdString(errors, 'password')"
          />
          <InputErrors
            :errors="errors"
            errorsIdPrefix="password"
            :class="pristine ? 'invalid-feedback d-block text-muted' : 'invalid-feedback'"
          />
        </b-form-group>
      </ValidationProvider>
    </b-col>
    <b-col v-if="!isAdmin" lg :class="vertical ? 'p-0' : ''">
      <ValidationProvider
        name="Password Confirmation"
        :rules="`required|is:${account.password}`"
        v-slot="{ errors, classes }"
      >
        <b-form-group label-for="confirmPassword">
          <template v-slot:label>
            <span class="req-ind">*</span>Confirm {{newPassword ? 'New': '' }} Password
          </template>
          <b-form-input
            id="confirmPassword"
            name="confirmPassword"
            v-model="confirmPassword"
            :placeholder="`Confirm${newPassword ? ' New ' : ' ' }Password`"
            type="password"
            :class="classes"
            autocomplete="none"
            :aria-describedby="$errorsIdString(errors, 'confirmPassword')"
          />
          <InputErrors :errors="errors" errorsIdPrefix="confirmPassword" />
        </b-form-group>
      </ValidationProvider>
    </b-col>
  </div>
</template>

<script>
export default {
  name: 'NewAccountInputs',
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    newPassword: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isGovEmail: {
      type: Boolean,
      default: false,
    },
    account: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      confirmPassword: '',
    };
  },
  methods: {
    getFeedbackClass(invalid) {
      return !invalid ? 'valid-feedback' : 'invalid-feedback';
    },
  },
};
</script>
